import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  messageBar: {
    marginBottom: pxToRem(20),
    color: theme.palette.neutralDark,
    selectors: {
      '.ms-MessageBar-icon i': {
        color: theme.palette.neutralDark,
      },
    },
  },
  thisIsADraftMessageTitle: {
    color: theme.palette.neutralDark,
  },
  thisIsADraftMessage: {
    color: theme.palette.neutralDark,
    fontWeight: 400,
  },
});
